/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CloneReport
 */
export interface CloneReport {
    /**
     *
     * @type {Array<string>}
     * @memberof CloneReport
     */
    changes?: Array<string>;
    /**
     *
     * @type {number}
     * @memberof CloneReport
     */
    created?: number;
    /**
     *
     * @type {string}
     * @memberof CloneReport
     */
    error?: string;
    /**
     *
     * @type {number}
     * @memberof CloneReport
     */
    errors?: number;
    /**
     *
     * @type {number}
     * @memberof CloneReport
     */
    removed?: number;
    /**
     *
     * @type {number}
     * @memberof CloneReport
     */
    skipped?: number;
    /**
     *
     * @type {number}
     * @memberof CloneReport
     */
    updated?: number;
}

export function CloneReportFromJSON(json: any): CloneReport {
    return CloneReportFromJSONTyped(json, false);
}

export function CloneReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloneReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'changes': !exists(json, 'changes') ? undefined : json['changes'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'error': !exists(json, 'error') ? undefined : json['error'],
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
        'removed': !exists(json, 'removed') ? undefined : json['removed'],
        'skipped': !exists(json, 'skipped') ? undefined : json['skipped'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
    };
}

export function CloneReportToJSON(value?: CloneReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'changes': value.changes,
        'created': value.created,
        'error': value.error,
        'errors': value.errors,
        'removed': value.removed,
        'skipped': value.skipped,
        'updated': value.updated,
    };
}
